
import {
  CustomQualityControlDto,
  CreateCustomQualityControlDto,
  UpdateCustomQualityControlDto,
} from './dtos'
import { BaseCrudService } from './BaseCrudService'
import { PaginatedQueryBase } from './api'

export type CustomQualityControlsFilters = PaginatedQueryBase & {
  includeInactive?: boolean
  search?: string
}

class CustomQualityControlService extends BaseCrudService<
  CustomQualityControlDto,
  CreateCustomQualityControlDto,
  UpdateCustomQualityControlDto,
  CustomQualityControlsFilters
> {
  constructor() {
    super('custom-quality-control', process.env.REACT_APP_RADIOPHARMACY_API_URL)
  }
}

export const customQualityControlService = new CustomQualityControlService()
